// extracted by mini-css-extract-plugin
module.exports = {"loader":"loading_loader__1ViEP","right5231":"loading_right5231__396b3","left036":"loading_left036__19K1S"};